import React from 'react';
import { motion } from 'framer-motion';

// Lightweight flowing lines - minimal animations
const FlowingLines = ({ variant = 'default' }) => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Single horizontal line */}
      <motion.div
        className="absolute h-px bg-gradient-to-r from-transparent via-[#FFD700]/15 to-transparent"
        style={{
          top: '25%',
          width: '100%',
        }}
        animate={{ x: ['-50%', '50%'] }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
      
      {/* Single vertical line */}
      <motion.div
        className="absolute w-px bg-gradient-to-b from-transparent via-[#FFD700]/10 to-transparent"
        style={{
          left: '75%',
          height: '100%',
        }}
        animate={{ y: ['-50%', '50%'] }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
    </div>
  );
};

export default FlowingLines;
